import { View, TouchableOpacity, Text, FlatList, ActivityIndicator } from 'react-native';
import ls from './style';
import useSingleRemoteConfig from '../../../../hooks/useSingleRemoteConfig';
import Accordion from '@sharedComponents/Accordion/Accordion';
import { ThemedPressable, ThemedText, ThemedView } from '@app/theme';

const FaqContainer = ({ navigation } : {navigation: any}) => {

  const {configValue , loading : faqLoading} = useSingleRemoteConfig('faq_data_list_home')

  const faqData  = configValue ? JSON.parse(configValue).splice(0,6)  : []


  const handlePress = () => {
    navigation.navigate('FAQ');
  };

  if(faqLoading && !configValue) {
    return (
      <ThemedView justifyContent='center' alignItems='center' minHeight={400} flex={1}>
        <ActivityIndicator />
      </ThemedView>
    )
  }


  return (
    <>
      <ThemedView backgroundColor='bg-surface-primary' my="2xl">
        <ThemedView p="lg" flexDirection='row' justifyContent='space-between' alignItems='center'>
          <ThemedText variant='h5s' color='text-primary'>
            FAQs
          </ThemedText>
          <ThemedPressable onPress={handlePress}>
          <ThemedText variant='b1s' color='text-action-primary'>
              View all
          </ThemedText>
          </ThemedPressable>
        </ThemedView>
        <FlatList
          contentContainerStyle={{ marginHorizontal: 16 }}
          data={faqData}
          renderItem={({ item }) => (
            <Accordion
              id={item.id}
              description={item.description}
              title={item.title}
            />
          )}
          showsVerticalScrollIndicator={true}
        />
      </ThemedView>
    </>
  );
};

export default FaqContainer;
